import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get tips List
export const getTipsList = createAsyncThunk(
  "getTipsList",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(`nutrition/get-tips${queryString}`);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Create Edit Tips
export const createTips = createAsyncThunk(
  "createTips",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`nutrition/add-tips`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Tips
export const updateTips = createAsyncThunk(
  "updateTips",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`nutrition/update-tips`, payload);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
      return rejectWithValue(error.response?.data);
    }
  }
);

// Delete tips
export const deleteTips = createAsyncThunk(
  "deleteTips",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/nutrition/delete-tips/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const tipsSlice = createSlice({
  name: "tips",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Get tips
      .addCase(getTipsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTipsList.fulfilled, (state, action) => {
        state.loading = false;
        state.getTipsListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getTipsList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = tipsSlice;
export default reducer;
